module.exports = __webpack_public_path__ + "static/media/logo-internal.58742a14.png";